import Image from 'next/image'
import clsx from 'clsx'
import { FC } from 'react'

import Button from 'components/parts/button/button'
import LectorsCircles from 'components/parts/lectors-circles/lectors-circles'

import { IBannerContent } from './data'

import styles from './banner-content.module.scss'

const BannerContent: FC<IBannerContent> = ({
  tags,
  badge,
  title,
  description,
  lectorsWithAvatar,
  dopLecturNames,
  dopLecturAmmount,
  mainColor,
  scrollHandler,
  isNamesBreaked,
  lectorsMod,
  isNotAuthorized,
}) => {
  return (
    <div className={styles.banner} style={{ background: mainColor }}>
      <div className={styles.bannerHeader}>
        <ul className={styles.tags}>
          {tags.map((tag) => {
            return (
              <li className={styles.tag} key={tag.name}>
                {tag.nmoIconData && <Image {...tag.nmoIconData} />}
                {tag.name}
              </li>
            )
          })}
        </ul>
        {badge && <div className={styles.badgeWrapper}>{badge}</div>}
      </div>

      <p className={styles.title} dangerouslySetInnerHTML={{ __html: title }} />
      <p className={styles.description}>{description}</p>

      <LectorsCircles
        lectursIds={lectorsWithAvatar}
        dopLecturNames={dopLecturNames}
        dopLecturAmmount={dopLecturAmmount}
        borderColor={mainColor}
        wrapperModificator={clsx(styles.lecturs, { [lectorsMod as string]: lectorsMod })}
        isNamesBreaked={isNamesBreaked}
      />
      <Button onClick={scrollHandler} modificator={styles.btn}>
        {isNotAuthorized ? 'Записаться на курс' : 'Оплатить курс'}
      </Button>
    </div>
  )
}

export default BannerContent
